import { useEffect, useRef } from "react";
import { msalConfig } from "../config/authConfig";
import { microsoftLearnerVerify } from "../utils/gameApplication/learnerProfile";
import {
  clearMsalInteractionState,
  getMicrosoftAuthErrorMessage,
  handleMsalRedirect,
  hasMicrosoftLoginInProgress,
  msalInstance,
} from "../config/msalClient";

const authConfigValid = Boolean(msalConfig?.auth?.clientId && msalConfig?.auth?.authority);

const getCallbackUrlDiagnostics = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));

  return {
    hrefWithoutCode: `${window.location.origin}${window.location.pathname}`,
    searchPresent: Boolean(window.location.search),
    hashPresent: Boolean(window.location.hash),
    searchHasCode: searchParams.has("code"),
    searchHasState: searchParams.has("state"),
    searchError: searchParams.get("error"),
    hashHasCode: hashParams.has("code"),
    hashHasState: hashParams.has("state"),
    hashError: hashParams.get("error"),
  };
};

const getMicrosoftEmail = (response:any) => {
  const claims = response?.idTokenClaims || {};
  const account = response?.account || {};
 
  
const data = {
  preferred_username:  claims.preferred_username ,
  email: claims.email 
}
  // return (
  //   claims.preferred_username ||
  //   claims.email ||
  //   claims.upn ||
  //   (Array.isArray(claims.emails) ? claims.emails[0] : undefined) ||
  //   account.username ||
  //   account.name
  // );
  return {
    data
  }
};

const returnToLoginWithSsoError = async (message:any, account?:any) => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");

  try {
    const cachedAccounts = msalInstance.getAllAccounts();
    const accountsToClear = account ? [account] : cachedAccounts;

   

    msalInstance.setActiveAccount(null);

    if (accountsToClear.length > 0) {
      await Promise.all(
        accountsToClear.map((cachedAccount:any) =>
          msalInstance.clearCache({ account: cachedAccount })
        )
      );
    } else {
      await msalInstance.clearCache();
    }
  } catch (error) {
    console.error("Failed to clear local Microsoft auth state:", error);
  } finally {
    clearMsalInteractionState();
  }

  sessionStorage.setItem("microsoftError", message);
  window.location.replace("/login");
};

export default function AuthCallback() {
  const callbackStarted = useRef(false);


     const  handleCallback = async() => {
   

      if (!authConfigValid) {
        const errorMessage = "Azure AD config invalid";
        console.error('Azure AD config invalid. Check REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_AUTHORITY.');
        sessionStorage.setItem("microsoftError", errorMessage);
        window.location.href = "/login";
        return;
      }

      let pendingTimer: number | undefined;

      try {
      
        let redirectSettled = false;
        pendingTimer = window.setTimeout(() => {
          if (!redirectSettled) {
            console.warn("[MSAL Callback] handleRedirectPromise is still pending after 8000ms", {
              path: window.location.pathname,
              url: getCallbackUrlDiagnostics(),
              loginInProgress: hasMicrosoftLoginInProgress(),
            });
          }
        }, 8000);

        const response = await handleMsalRedirect();
        redirectSettled = true;
        window.clearTimeout(pendingTimer);

        if (!response) {
          const errorMessage = "Microsoft login response empty";
          console.error("[MSAL Callback] redirect response is null", {
            path: window.location.pathname,
            search: window.location.search,
            hashPresent: Boolean(window.location.hash),
            url: getCallbackUrlDiagnostics(),
            accounts: msalInstance.getAllAccounts().map((account) => account.username),
            loginInProgress: hasMicrosoftLoginInProgress(),
          });
          await returnToLoginWithSsoError(errorMessage);
          return;
        }

      

        if (response.account) {
          msalInstance.setActiveAccount(response.account);
        }

        const MicrosoftResponseemail:any = getMicrosoftEmail(response);
        

        if (!MicrosoftResponseemail?.data?.email &&!MicrosoftResponseemail?.data?.preferred_username) {
          const errorMessage = "Email not found in Microsoft account";
          console.error(errorMessage, response);
          await returnToLoginWithSsoError(errorMessage, response.account);
          return;
        }

     
        const payloaddata =  MicrosoftResponseemail.data;
        const data = await microsoftLearnerVerify({ payloaddata });
       

        if (data?.status !== "Success" || !data?.token) {
          const errorMessage = data?.message || "Microsoft login failed";
          console.error("Microsoft login failure payload:", data);
          await returnToLoginWithSsoError(errorMessage, response.account);
          return;
        }

        const user = {
          data: data.data,
          token: data.token,
          role: data.data?.role || "Learner",
        };
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", data.token);
        clearMsalInteractionState();

       
        window.location.href = "/game/gamePlay";
      } catch (error) {
        if (pendingTimer) {
          window.clearTimeout(pendingTimer);
        }

        const errorMessage = getMicrosoftAuthErrorMessage(error);
        console.error("[MSAL Callback] error:", error);
        await returnToLoginWithSsoError(errorMessage);
      }
    }
      useEffect(() => {
    if (callbackStarted.current) {
     
      return;
    }
 
    callbackStarted.current = true;
    handleCallback();
  }, []);
  return (<div>Signing in...</div>);
}
